import { combineReducers } from 'redux';
import { dataReducer } from './data-reducer.js';
import { featureReducer } from './feature-reducer.js';

export const reducers = combineReducers({
  data: dataReducer,
  feature: featureReducer,
});
